import { Mat4 } from "@base/math/Mat4";
import { IVec3, Vec3 } from "@base/math/Vec3";
import { INetPositionOptions } from "@biz/definitions/MountDefinitons";
import { SST } from "@biz/definitions/SST";
import { ISunSailData, PoleId } from "@biz/definitions/SunSailDefinitions";
import { Poles } from "@biz/items/sunSail/logic/Poles";
import { SunSailMath } from "@biz/items/sunSail/logic/SunSailMath";
import { TriangleHelper } from "@biz/items/sunSail/logic/TriangleHelper";
import { PoleHelper } from "./PoleHelper";
import { SunSailLogic } from "./SunSailLogic";

export class LogicFixed {
  static calcMountPositions(sunSail: ISunSailData, _axleIndex: number, options?: INetPositionOptions): IVec3[] {
    const { id: sunSailId, positionMode } = sunSail;

    const cornerPoles = Poles.getPoles(sunSail, "corner");

    switch (positionMode || "bottom") {
      case "mount": return cornerPoles.map((_p, i) => SunSailLogic.getPoleMountPositionModePos(sunSail, i, 0))
      case "net": throw new Error("Not supported so far!"); // return cornerPoles.map((_p, i) => SunSailLogic.getPolePos(sunSail, i))
      case "bottom": {
        const mount: IVec3[] = [];

        for (let i = 0; i < cornerPoles.length; i++) {
          const pole = cornerPoles[i];

          const mountPosDelta = SunSailLogic.calcMountPosDelta(sunSail, i);
          const lengthBVal = SunSailLogic.getPoleLengthB(sunSail, i);
          const topMountY = SunSailLogic.calcTopMountY(sunSail, i);
          const poleAngle = SunSailLogic.getPoleAngle(sunSail, i);
          const poleLength = SunSailLogic.getPoleLength(sunSail, i);
          const heightChangeOffset = options?.heightChangeOffsets === undefined ? 0 : (Array.isArray(options?.heightChangeOffsets) ? options?.heightChangeOffsets[i] : options?.heightChangeOffsets);
          const m = PoleHelper.calcMatrixForLengthPos(sunSailId, i, poleLength, poleAngle, lengthBVal, SunSailLogic.calcBottomPoleExtension(sunSail, i), SunSailLogic.calcPoleOffsetY(sunSail, i), poleLength - topMountY + mountPosDelta.y - heightChangeOffset);

          const rotationY = SunSailLogic.calcGroundRotation(sunSail, i);
          const groundMatrix = SunSailLogic.calcPoleGroundMatrixFromValues(pole.position, rotationY);

          const mountPos = Vec3.applyMatrix4(Vec3.xz(mountPosDelta), Mat4.mul(groundMatrix, m));
          mount[i] = mountPos;
        }
        return mount;
      }
      default: throw new Error("LogicFixed.calcMountPosition: PositionMode not supported so far: " + positionMode)
    }
  }

  static calcGroundRotation(_sunSailId: string, poleId: PoleId, sunSail: ISunSailData): number {
    const positionType = Poles.getPolePositionType(poleId);
    if (positionType === "center") {
      return 0;
    }

    const left = SunSailLogic.getPolePos(sunSail, poleId, { offset: 1 });
    const right = SunSailLogic.getPolePos(sunSail, poleId, { offset: -1 });
    const vec = Poles.getPole(sunSail, poleId).halfVec ?? TriangleHelper.calcHalfVector(Poles.getPole(sunSail, poleId).position, left, right, { correctDir: SST.is(sunSail.sunSailType, SST.Sandy) ? "right" : undefined });
    return SunSailMath.calcGroundRotationFromVec(vec);
  }

}